import React from 'react'
import Hero from './Hero'
import About from './About'
import CardList from './Card/CardList'
import WhyChouseUs from './WhyChouseUs'
import Review from './Review'
import PricingCards from './PricingCards'
import ContactForm from './ContactForm'

const Home = () => {
  return (
    <>
    <Hero />
    <About />
    <CardList />
    <WhyChouseUs />
    <Review />
    <PricingCards />
    <ContactForm />
    
    
    </>
  )
}

export default Home
